module.exports = __webpack_public_path__ + "images/application/switch-guide-blue@2x-92dbf742.png";